const DEFAULT_DELAY_MS = 5000;
const DEFAULT_HOME_URL = "/";
const DEFAULT_REF_PARAM = "ref=404_redirect";

const buildRedirectUrl = (homeUrl, refParam) => {
  if (!homeUrl) return null;

  const separator = homeUrl.indexOf("?") === -1 ? "?" : "&";
  return `${homeUrl}${separator}${refParam}`;
};

export default () => {
  const marker = document.querySelector(".js-404-redirect");
  if (!marker) return;

  const homeUrl = marker.getAttribute("data-home-url") || DEFAULT_HOME_URL;
  const refParam = marker.getAttribute("data-ref-param") || DEFAULT_REF_PARAM;
  const parsedDelay = parseInt(marker.getAttribute("data-delay"), 10);
  const delay = Number.isFinite(parsedDelay) && parsedDelay >= 0 ? parsedDelay : DEFAULT_DELAY_MS;

  const redirectUrl = buildRedirectUrl(homeUrl, refParam);
  if (!redirectUrl) return;

  window.setTimeout(() => {
    window.location.assign(redirectUrl);
  }, delay);
};
